import React from 'react';
import PropTypes from 'prop-types';

/**
 * Reusable table component
 * @param {Object} props
 * @param {Array} props.columns - Array of column headers
 * @param {Array} props.data - Array of row data
 * @param {Function} props.renderRow - Function to render each row
 */
function Table({ columns, data, renderRow }) {
  return (
    <div className="table-responsive">
      <table className="table table-striped table-hover">
        <thead>
          <tr>
            {columns.map((col, index) => (
              <th key={index}>{col}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={columns.length} className="text-center">
                No data available
              </td>
            </tr>
          ) : (
            data.map((item, index) => renderRow(item, index))
          )}
        </tbody>
      </table>
    </div>
  );
}

Table.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.string).isRequired,
  data: PropTypes.array.isRequired,
  renderRow: PropTypes.func.isRequired,
};

export default Table;